import RegistrationStep1 from "./steps/Step1.tsx";
import RegistrationStep2 from "./steps/Step2.tsx";
import RegistrationStep3 from "./steps/Step3.tsx";
import { RegistrationWizard } from "./RegistrationWizard";

import { useRegistrationStore } from "@/store/registrationStore.ts";

const RegistrationPage = () => {
	const { step } = useRegistrationStore();

	return (
		<RegistrationWizard>
			{step === 1 && <RegistrationStep1 />}
			{step === 2 && <RegistrationStep2 />}
			{step === 3 && <RegistrationStep3 />}
		</RegistrationWizard>
	);
};

export default RegistrationPage;
